import { useQuery } from '@tanstack/react-query';
import { fetchExamCategories } from '../services/examCategoryService';

function sortExams(exams = []) {
  return [...exams].sort((left, right) => {
    const leftPriority =
      (Number(left?.is_user_exam) ? -20 : 0) +
      (Number(left?.is_subscribed) ? -10 : 0) +
      Number(left?.md_exams_id || 0);
    const rightPriority =
      (Number(right?.is_user_exam) ? -20 : 0) +
      (Number(right?.is_subscribed) ? -10 : 0) +
      Number(right?.md_exams_id || 0);

    return leftPriority - rightPriority;
  });
}

function normalizeSubscribedExams(data) {
  const exams = Array.isArray(data?.subscribed_exams) ? data.subscribed_exams : [];

  return sortExams(exams.filter((exam) => exam?.md_exams_id));
}

export function useExamCategories(options = {}) {
  return useQuery({
    queryKey: ['examCategories'],
    queryFn: async () => {
      const data = await fetchExamCategories();
      const exams = normalizeSubscribedExams(data);
      const subscribedExams = exams.filter((exam) => Number(exam?.is_subscribed) === 1);
      const favoriteExams = exams.filter((exam) => Number(exam?.is_favourite) === 1);
      const myStateExams = exams.filter(
        (exam) =>
          Number(exam?.state_id) > 0 &&
          Number(exam?.is_user_exam) === 1
      );
      const otherExams = exams.filter(
        (exam) =>
          Number(exam?.is_subscribed) !== 1 &&
          Number(exam?.is_favourite) !== 1 &&
          Number(exam?.is_user_exam) !== 1
      );

      return {
        exams,
        subscribedExams,
        favoriteExams,
        myStateExams,
        otherExams,
        categories: Array.isArray(data?.categories_list) ? data.categories_list : [],
      };
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnMount: options.refetchOnMount ?? true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    placeholderData: (previousData) =>
      previousData ?? {
        exams: [],
        subscribedExams: [],
        favoriteExams: [],
        myStateExams: [],
        otherExams: [],
        categories: [],
      },
  });
}
